import ErrorComponent from "@/components/atoms/ErrorComponent";
import CompanyStatusHeader from "@/components/molecules/card-headers/companies/CompanyStatusHeader";
import CompanyStatusDetailsCard from "@/components/molecules/cards/companies/CompanyStatusDetailsCard";
import { UUID_REGEX } from "@/constants/regexs";
import CompanyStatus from "@/interfaces/CompanyStatus";

import { FC, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useParams } from "react-router-dom";

const CompanyStatusView: FC = () => {
  const { id } = useParams<{ id: string }>();
  const [companyStatus, setCompanyStatus] = useState<CompanyStatus>();
  const [totals, setTotals] = useState({
    companies: 0,
  });

  const onGetTotal = (key: string, total: number) => {
    setTotals((prev) => ({ ...prev, [key]: total }));
  };

  if (!id || !UUID_REGEX.test(id)) {
    return (
      <ErrorComponent error={{ status: 404, data: {} }} absolute returnButton />
    );
  }
  return (
    <div className="formalys-page formalys-detail-page">
      {companyStatus && <CompanyStatusHeader id={id} />}
      <Row className="g-3">
        <Col xxl={4} xl={5}>
          <CompanyStatusDetailsCard id={id} card callBack={setCompanyStatus} />
        </Col>
      </Row>
    </div>
  );
};

export default CompanyStatusView;
